import React, { useState, FormEvent, useContext, useEffect } from "react";
import { Segment, Form, Button } from "semantic-ui-react";
import { IFttcHour } from "../../../app/models/fttchour";
import FttcHourStore from "../../../app/stores/fttchourStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

interface DetailParams {
  id: string;
}

const FttcHourEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const fttchourStore = useContext(FttcHourStore);
  const { editFttcHour, submitting, loadFttcHour, clearFttcHour } =
    fttchourStore;

  const [fttchour, setFttcHour] = useState<IFttcHour>({
    id: "",
    createdAt: "",
    updatedAt: "",
    financialYear: "",
    payRun: "",
    workOrder: "",
    sorId: "",
    description: "",
    amount: 0,
    tech: "",
    startDate: "",
    comment: "",
  });

  useEffect(() => {
    loadFttcHour(match.params.id).then((fttchour) => {
      setFttcHour(fttchour);
    });

    return () => {
      clearFttcHour();
    };
  }, [loadFttcHour]);

  const handleSubmit = () => {
    editFttcHour(fttchour).then(() =>
      history.push(`/financemanagement/fttchour`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setFttcHour({ ...fttchour, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label="Financial Year"
          onChange={handleInputChange}
          name="financialYear"
          placeholder="Financial Year"
          value={fttchour.financialYear}
        />
        <Form.Input
          label="Pay Run"
          onChange={handleInputChange}
          name="payRun"
          placeholder="Pay Run"
          value={fttchour.payRun}
        />
        <Form.Input
          label="Work Order"
          onChange={handleInputChange}
          name="workOrder"
          placeholder="Work Order"
          value={fttchour.workOrder}
        />
        <Form.Input
          label="SOR"
          onChange={handleInputChange}
          name="sor"
          placeholder="SOR"
          value={fttchour.sorId}
        />
        <Form.Input
          label="Work Order Lines Description"
          onChange={handleInputChange}
          name="workOrder"
          placeholder="Work Order Lines Description"
          value={fttchour.workOrder}
        />
        <Form.Input
          label="Amount"
          onChange={handleInputChange}
          name="amount"
          placeholder="Amount"
          value={fttchour.amount}
        />
        <Form.Input
          label="Tech"
          onChange={handleInputChange}
          name="tech"
          placeholder="Tech"
          value={fttchour.tech}
        />
        <Form.Input
          label="Start Date"
          onChange={handleInputChange}
          name="startDate"
          type="date"
          placeholder="Start Date"
          value={fttchour.startDate}
        />

        <Form.Input
          label="Comment"
          onChange={handleInputChange}
          name="comment"
          placeholder="Comment"
          value={fttchour.comment}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/financemanagement/fttchour")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(FttcHourEditForm);
